<template>
  <div>
    <div class="w-full py-2 mobile-Menu-container flex justify-between px-4">
      <div class="w-full h-10 pr-24">
        <img src="@/assets/bottomLogo.png" alt="logo" class="w-full" />
      </div>
      <div class="w-10 h-10" @click="handleSetIsMenuVisible">
         <img src="@/assets/menu.svg" alt="" v-if="!isMenuVisible"/>
         <img src="@/assets/close.svg" alt="" v-else/>
      </div>
    </div>
    <div v-show="isMenuVisible">
      <MobileMenu @setIsMenuVisible="handleSetIsMenuVisible" />
    </div>
  </div>
</template>

<script>
import MobileMenu from "./MobileMenu.vue";
export default {
  components: { MobileMenu },
  props: {
    isMenuVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSetIsMenuVisible() {
      this.$emit("setIsMenuVisible", !this.isMenuVisible);
    },
  },
};
</script>

<style scoped>
.mobile-Menu-container {
  background-image: url("~@/assets/logoBg.png");
  background-size: cover;
}
</style>
